import React from "react";
import FormControl from "@/components/FormControl/FormControl";
import {
  get,
  type Control,
  type FieldValues,
  type UseFormRegister,
  type UseFormStateReturn,
} from "react-hook-form";
import FieldArrayWithLabelAndError from "@/components/FormControl/FieldArray/FieldArray";
import FieldArray from "@/components/FormControl/FieldArray/FieldArray";

type FormFieldConfig = {
  controlType: string;
  label: string;
  placeholder?: string;
  validations?: Record<string, any>;
  isDisabled?: boolean;
  isRequired?: boolean;
  autoComplete?: string;
  isControlled?: boolean;
  props?: Record<string, any>;
  hide?: boolean;
  options?: any[];
  slabFields?: Record<string, any>;
  onFieldClick?: () => void;
  className?: string;
};

type FormConfig = Record<string, FormFieldConfig>;

export default function formRenderer<TFieldValues extends FieldValues>(
  formConfig: FormConfig,
  formState: UseFormStateReturn<TFieldValues>,
  register: UseFormRegister<TFieldValues>,

  control?: Control<TFieldValues>,
  options?: { showSymbols?: boolean }
) {
  const showSymbols = options?.showSymbols || false;

  return Object.entries(formConfig || []).map(([name, obj]) => {
    if (obj?.hide) return null;
    if (obj.controlType === "fieldArray") {
      return (
        <div key={name} style={{ gridColumn: "1 / -1" }}>
          <FieldArray
            name={name}
            control={control}
            slabFields={obj.slabFields}
            label={obj.label}
            className={obj.className || ""}
            controlType={undefined}
            errorMessage={undefined}
            isRequired={undefined}
          />
        </div>
      );
    }
    if (obj.controlType === "rowBreak") {
      return <div key={name} className={obj.className || ""} />;
    }

    return (
      <div className={obj.className ? obj.className : ""} key={name}>
        <FormControl
          key={name}
          name={name}
          controlType={obj.controlType}
          label={obj.label}
          placeholder={obj.placeholder || `Enter ${obj.label}`}
          validations={obj.validations}
          errorMessage={get(formState.errors, name)?.message}
          isRequired={obj.isRequired}
          options={obj.options}
          autoComplete={obj.autoComplete || "new-password"}
          {...(obj.isControlled ? { control } : { register })}
          {...(obj.props || {})}
          // {...(obj.isControlled && control ? { control } : { register })}
          {...(obj.props || {})}
          onFieldClick={obj.onFieldClick}
          isDisabled={obj.isDisabled}
        />
      </div>
    );
  });
}
